import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  Typography,
  Grid,
  Box,
  Chip,
  Divider,
  Stack,
  LinearProgress,
  Paper,
} from '@mui/material';
// import { HomeIcon } from '@mui/icons-material';
import {
  Workspaces as WorkspacesIcon,
  Assessment as AssessmentIcon,
  History as HistoryIcon,
  CrisisAlert as CrisisAlertIcon,
  Foundation as FoundationIcon,
  Map as MapIcon,
  CategoryOutlined as CategoryOutlinedIcon,
  PrecisionManufacturing as PrecisionManufacturingIcon,
  Construction as ConstructionIcon,
  EmojiEmotions as EmojiEmotionsIcon,
  Handshake as HandshakeIcon,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';

const mockFunnelGroups = [
  {
    id: 1,
    name: 'Продажи',
    icon: WorkspacesIcon,
    funnels: [
      {
        id: 1,
        name: 'Продажи',
        stats: 'Лидов: 245 | Завершено этапов: 67%',
      },
      {
        id: 2,
        name: 'Производство',
        stats: 'Лидов: 112 | Завершено этапов: 78%',
      },
      {
        id: 3,
        name: 'Строительство',
        stats: 'Лидов: 389 | Завершено этапов: 52%',
      },
    ],
  },
  {
    id: 2,
    name: 'Поддержка',
    icon: FoundationIcon,
    funnels: [
      {
        id: 4,
        name: 'Техническая поддержка',
        stats: 'Тикетов: 156 | Закрыто: 134 | Рейтинг: 4.8',
      },
      {
        id: 5,
        name: 'Консультации',
        stats: 'Запросов: 89 | Выполнено: 76 | Рейтинг: 4.5',
      },
    ],
  },
];

const mockNews = [
  { title: 'Новая интеграция с Telegram', time: '2 часа назад' },
  { title: 'Обновление алгоритма скоринга', time: '1 день назад' },
  { title: 'Запуск A/B тестирования форм', time: '3 дня назад' },
];

const mockTasks = [
  { title: 'Обработать лиды из звонков', priority: 'high' },
  { title: 'Подготовить отчет по продажам', priority: 'medium' },
  { title: 'Провести встречу с клиентом', priority: 'low' },
];

const mockReports = [
  { name: 'Продажи за месяц', value: 1250000, trend: 'up' },
  { name: 'Конверсия лидов', value: 23.5, trend: 'down' },
  { name: 'Средний чек', value: 45000, trend: 'up' },
];

const Dashboard = () => {
  const { permissions } = useSelector((state) => state.auth);

  const visibleCards = {
    describtion: permissions?.dashboard?.describtion,
    funnels: permissions?.dashboard?.funnels,
    news: permissions?.dashboard?.news,
    reports: permissions?.dashboard?.reports,
    tasks: permissions?.dashboard?.tasks,
    calendar: permissions?.dashboard?.calendar,
    progress: permissions?.dashboard?.progress,
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'error';
      case 'medium':
        return 'warning';
      case 'low':
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <Box
      sx={{
        p: 3,
        // bgcolor: 'grey.50',
        minHeight: '100vh',
      }}
    >
      {/* <Typography variant='h4' gutterBottom>
        Главная страница CRM
      </Typography> */}

      {/* <Divider sx={{ mb: 3 }} /> */}
      {visibleCards?.describtion && (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          <Grid item xs={12}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Typography
                    variant='h5'
                    color='primary'
                    gutterBottom
                    sx={{ fontWeight: 600 }}
                  >
                    Наша философия
                  </Typography>
                  <Typography
                    variant='subtitle1'
                    color='text.secondary'
                    sx={{ mb: 4 }}
                  >
                    Три этапа от мечты к дому
                  </Typography>

                  <Grid container spacing={3} sx={{ mb: 4 }}>
                    {/* Этап 1: Продажи */}
                    <Grid item xs={12}>
                      <Paper
                        elevation={2}
                        sx={{
                          p: 3,
                          height: '100%',
                          borderTop: 3,
                          borderColor: 'primary.main',
                          borderRadius: 2,
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: 4,
                          },
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
                        >
                          <HandshakeIcon
                            color='primary'
                            sx={{ mr: 1.5, fontSize: 28 }}
                          />
                          <Typography
                            variant='h6'
                            color='primary'
                            sx={{ fontWeight: 600 }}
                          >
                            Продажи
                          </Typography>
                        </Box>
                        <Typography
                          variant='h6'
                          gutterBottom
                          sx={{ fontWeight: 500, mb: 2 }}
                        >
                          Каждая сделка — начало дома.
                        </Typography>
                        <Typography
                          variant='body2'
                          color='text.secondary'
                          paragraph
                        >
                          Это старт всего пути. Без доверия и договора не будет
                          ни производства, ни строительства.
                        </Typography>
                        <Typography variant='body2' color='text.secondary'>
                          Здесь мы даем обещание.
                        </Typography>
                      </Paper>
                    </Grid>

                    {/* Этап 2: Производство */}
                    <Grid item xs={12}>
                      <Paper
                        elevation={2}
                        sx={{
                          p: 3,
                          height: '100%',
                          borderTop: 3,
                          borderColor: 'secondary.main',
                          borderRadius: 2,
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: 4,
                          },
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
                        >
                          <PrecisionManufacturingIcon
                            color='secondary'
                            sx={{ mr: 1.5, fontSize: 28 }}
                          />
                          <Typography
                            variant='h6'
                            color='secondary'
                            sx={{ fontWeight: 600 }}
                          >
                            Производство
                          </Typography>
                        </Box>
                        <Typography
                          variant='h6'
                          gutterBottom
                          sx={{ fontWeight: 500, mb: 2 }}
                        >
                          Каждый комплект — суть дома.
                        </Typography>
                        <Typography
                          variant='body2'
                          color='text.secondary'
                          paragraph
                        >
                          Это не просто детали. Это этап, где дом обретает свой
                          характер, прочность и индивидуальность.
                        </Typography>
                        <Typography variant='body2' color='text.secondary'>
                          Мы создаем идеальную основу.
                        </Typography>
                      </Paper>
                    </Grid>

                    {/* Этап 3: Строительство */}
                    <Grid item xs={12}>
                      <Paper
                        elevation={2}
                        sx={{
                          p: 3,
                          height: '100%',
                          borderTop: 3,
                          borderColor: 'success.main',
                          borderRadius: 2,
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: 4,
                          },
                        }}
                      >
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
                        >
                          <ConstructionIcon
                            color='success'
                            sx={{ mr: 1.5, fontSize: 28 }}
                          />
                          <Typography
                            variant='h6'
                            color='success.main'
                            sx={{ fontWeight: 600 }}
                          >
                            Строительство
                          </Typography>
                        </Box>
                        <Typography
                          variant='h6'
                          gutterBottom
                          sx={{ fontWeight: 500, mb: 2 }}
                        >
                          Каждая стройка — воплощение обещания.
                        </Typography>
                        <Typography
                          variant='body2'
                          color='text.secondary'
                          paragraph
                        >
                          Здесь сходятся все этапы. Доверие клиента и качество
                          домокоплектов нашими руками превращаются в реальный
                          дом.
                        </Typography>
                      </Paper>
                    </Grid>
                  </Grid>

                  {/* Итоговый блок */}
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      bgcolor: 'background.default',
                      border: 1,
                      borderColor: 'divider',
                      borderRadius: 2,
                      textAlign: 'center',
                    }}
                  >
                    {/* <EmojiEmotionsIcon
                      sx={{ color: 'warning.main', fontSize: 32, mb: 2 }}
                    /> */}
                    <Typography
                      variant='h6'
                      sx={{
                        fontWeight: 500,
                        lineHeight: 1.5,
                        fontStyle: 'italic',
                        color: 'text.primary',
                      }}
                    >
                      {/* Потому что мы знаем:{' '} */}
                      <Box
                        component='span'
                        sx={{ color: 'warning.dark', fontWeight: 700 }}
                      >
                        наша работа сегодня — это чья-то семья и воспоминания
                        завтра.
                      </Box>
                    </Typography>
                  </Paper>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
      {/* Блоки карточек групп воронок */}
      {visibleCards?.funnels && (
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {mockFunnelGroups.map((group) => {
            const Icon = group.icon;
            return (
              <Grid item xs={12} md={6} lg={4} key={group.id}>
                <Card sx={{ height: '100%' }}>
                  <CardHeader
                    avatar={<Icon color='primary' />}
                    title={group.name}
                    titleTypographyProps={{ variant: 'h6' }}
                  />
                  <CardContent>
                    <List disablePadding>
                      {group.funnels.map((funnel) => (
                        <ListItem key={funnel.id} divider sx={{ py: 1.5 }}>
                          <ListItemText
                            primary={
                              <Typography variant='body1' fontWeight='bold'>
                                {funnel.name}
                              </Typography>
                            }
                            secondary={
                              <Typography
                                variant='body2'
                                color='text.secondary'
                                sx={{ fontSize: '0.875rem' }}
                              >
                                {funnel.stats}
                              </Typography>
                            }
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}

      {/* Новости, Отчеты, Задачи */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {visibleCards?.news && (
          <Grid item xs={12} lg={4}>
            <Card>
              <CardHeader
                avatar={<HistoryIcon color='info' />}
                title='Новости'
                titleTypographyProps={{ variant: 'h6' }}
              />
              <CardContent>
                <List disablePadding>
                  {mockNews.map((item, index) => (
                    <Box key={index} sx={{ mb: 2 }}>
                      <Typography variant='body1'>{item.title}</Typography>
                      <Typography variant='caption' color='text.secondary'>
                        {item.time}
                      </Typography>
                      {index < mockNews.length - 1 && (
                        <Divider sx={{ mt: 1.5 }} />
                      )}
                    </Box>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        )}

        {visibleCards?.reports && (
          <Grid item xs={12} lg={4}>
            <Card>
              <CardHeader
                avatar={<AssessmentIcon color='success' />}
                title='Ключевые отчеты'
                titleTypographyProps={{ variant: 'h6' }}
              />
              <CardContent>
                <Stack spacing={2}>
                  {mockReports.map((report, index) => (
                    <Box key={index}>
                      <Typography variant='body2' color='text.secondary'>
                        {report.name}
                      </Typography>
                      <Typography variant='h6'>{report.value}</Typography>
                    </Box>
                  ))}
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        )}

        {visibleCards?.tasks && (
          <Grid item xs={12} lg={4}>
            <Card>
              <CardHeader
                avatar={<ConstructionIcon color='warning' />}
                title='Задачи'
                titleTypographyProps={{ variant: 'h6' }}
              />
              <CardContent>
                <List disablePadding>
                  {mockTasks.map((task, index) => (
                    <ListItem key={index} divider>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <ListItemText primary={task.title} />
                        <Chip
                          label={task.priority.toUpperCase()}
                          color={getPriorityColor(task.priority)}
                          size='small'
                        />
                      </Box>
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>

      {/* Дополнительные блоки */}
      <Grid container spacing={3}>
        {visibleCards?.calendar && (
          <Grid item xs={12} md={visibleCards?.progress ? 8 : 12}>
            <Paper sx={{ p: 2, height: 400 }}>
              <Typography variant='h6' sx={{ mb: 2 }}>
                Календарь событий{' '}
                <MapIcon sx={{ ml: 1, verticalAlign: 'middle' }} />
              </Typography>
              {/* Здесь можно добавить календарь MUI или другой компонент */}
              <Box
                sx={{
                  // bgcolor: 'grey.100',
                  height: 300,
                  borderRadius: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography color='text.secondary'>
                  Интеграция календаря
                </Typography>
              </Box>
            </Paper>
          </Grid>
        )}
        {visibleCards?.progress && (
          <Grid item xs={12} md={visibleCards?.calendar ? 4 : 12}>
            <Paper sx={{ p: 2 }}>
              <Typography variant='h6' sx={{ mb: 2 }}>
                Прогресс по целям{' '}
                <CategoryOutlinedIcon sx={{ ml: 1, verticalAlign: 'middle' }} />
              </Typography>
              <Stack spacing={2}>
                <Box>
                  <Typography variant='caption'>Продажи</Typography>
                  <LinearProgress
                    variant='determinate'
                    value={75}
                    color='success'
                  />
                </Box>
                <Box>
                  <Typography variant='caption'>Поддержка</Typography>
                  <LinearProgress
                    variant='determinate'
                    value={40}
                    color='warning'
                  />
                </Box>
                <Box>
                  <Typography variant='caption'>Конверсия</Typography>
                  <LinearProgress
                    variant='determinate'
                    value={90}
                    color='primary'
                  />
                </Box>
              </Stack>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Dashboard;
